import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import sessionStorageHelper from 'utils/SessionStorageHelper';
import { sessionStorageKeys } from 'constants/sessionStorageKeys';

import orderViews from './orderViews';

import './dataViewing.scss';

@inject('orderStore')
@observer
class DataViewing extends Component {
  constructor(props) {
    super(props);

    this.refreshData = this.refreshData.bind(this);
  }

  refreshData() {
    let values = this.props.location.state;
    if (values) {
      sessionStorageHelper.set(sessionStorageKeys.orderSearchCriteria, values);
    } else {
      values = sessionStorageHelper.get(sessionStorageKeys.orderSearchCriteria);
    }

    this.props.orderStore.loadData(values);
  }

  componentWillMount() {
    if (!this.props.orderStore.viewId) {
      this.refreshData();
    }
  }

  render() {
    const OrderView = orderViews[this.props.orderStore.viewId];
    const showOrder = !this.props.orderStore.orderDataLoadInProgress && OrderView;

    return (
      <div className="data-viewing-page">
        <div className="page-body">
          {showOrder && <OrderView order={this.props.orderStore.order} onRefresh={this.refreshData} />}
        </div>
      </div>
    );
  }
}

export default DataViewing;



// WEBPACK FOOTER //
// ./src/containers/DataViewing/DataViewing.jsx